import { memo, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/AddRounded';
import _map from 'lodash/map';
// Local files
import { Root, StyledList } from './List.styled';
import Item from './Item/Item';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import Search from 'components/Common/Search/Search';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useClinicians from 'hooks/useClinicians';
import { cliniciansSelectors } from 'features/clinicians'

const CliniciansList = () => {
  const navigate = useNavigate();
  const { setClinicianDrawer } = useApp();
  const { getClinicians, clearLocalClinicians, clearLocalActiveClinician } = useClinicians();
  const { data, pagination } = useCustomSelector(cliniciansSelectors.getCliniciansData)
  const fetching = useCustomSelector(cliniciansSelectors.cliniciansIsFetching)
  const [query, setQuery] = useState('');

  const fetchClinicians = useCallback((offset, query) => {
    getClinicians({ offset, query })
  }, [getClinicians]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
  scrollTop >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchClinicians(pagination.limit + pagination.offset, query);
  const handleCloseActiveClinician = (e) => { 
    e.stopPropagation();
    clearLocalActiveClinician()
    navigate('/providers');
  };
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      clearLocalClinicians();
      fetchClinicians(0, query);
    }, !!query ? 500 : 0);
      
    return () => {
      clearTimeout(timeout);
    }
  }, [query, fetchClinicians, clearLocalClinicians]);
  useEffect(() => {
    return clearLocalClinicians
  }, [clearLocalClinicians]);

  return (
    <Root onClick={handleCloseActiveClinician}>
      <Box sx={{ display: 'flex', gap: '2px', alignItems: 'center', p: '12px 16px 8px' }}>
        <Search fullWidth value={query} onChange={setQuery} />
        <Button
          variant='contained'
          color='primary'
          sx={{ minWidth: 'unset', height: 30, width: 30, p: .5, borderRadius: '50%' }}
          onClick={() => setClinicianDrawer({ open: true, edit: false })}
        >
         <AddIcon />
        </Button>
      </Box>
      <StyledList onScroll={handleScroll}>
        {_map(data, (m) => <Item key={m.id} {...m} />)}
        {fetching && <ListSkeleton />}
      </StyledList>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <CliniciansList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);